// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"01a28686","453":"2f01105d","455":"320c1810","700":"3761aff4","711":"8a319391","797":"d3d8c898","847":"b82a72f4","977":"989787dc"}[chunkId] + ".chunk.js";
};